module.exports = __webpack_public_path__ + "static/img/Frame_4121@2x.a5a0bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4121@2x.png
// module id = PrJv
// module chunks = 64